module.exports = __webpack_public_path__ + "static/media/now-frozen-dt-en.2cab1e47.jpg";